export default {
    props: ['studyId','studytime'],
    data(){
        return {
            id:'',
            time:'',
            timer:'',
            nowTime:'',
            sumTime:'',
            nowLongTime:'',
            videoObj:'',
            progress:0,
        }
    },
    methods:{
        getResourse(){
            this.$post('resources/get',{id:this.id,token:this.$store.state.id}).then(res=>{
                let url=res.data.result.data;
                this.videoPlay(url,this.time)//第一次进入
            });
        },
        videoPlay: function (url, time) {
            // console.log('videoPlay接收参数')
            // console.log(url,time)
            let currentTime = time;
            // console.log('时间',currentTime);
            let numVal = ((1 - 140 / document.body.offsetHeight));
            let eleHeight = document.body.offsetHeight * numVal;
            let isAuth = this.$route.query.isAuth;
            let isPlayer = 'on';
            let me = this;
            this.videoUrl = url;
            currentTime ? currentTime : currentTime = 0;
            isAuth == '1' ? isPlayer : isPlayer = 'off';
            var player = polyvObject(
                "#plv_1"
            ).videoPlayer({
                width: '100%',
                height: [eleHeight],
                vid: url,
                'flashvars': { "watchStartTime": currentTime, "ban_seek_by_limit_time": isPlayer, 'ban_history_time': 'on' }
            });
            // console.log(numVal,eleHeight,document.body.offsetHeight)
            this.videoObj = player;
            //计算上面视频右上角的定时器
                this.nowTime = this.timeResult(currentTime);
            this.timer = setInterval(function () {
                let baoliTime = me.videoObj.j2s_getCurrentTime();
                baoliTime >= me.nowLongTime ? me.nowLongTime = baoliTime : me.nowLongTime;
                this.progress = me.nowLongTime / me.videoObj.j2s_getDuration();
                this.progress = 1-this.progress <= 0.001 ? 1:this.progress;
                // console.log(this.progress+'进度')
                me.nowTime = me.timeResult(Math.max(baoliTime, me.nowLongTime));
                me.$emit('listenProgress', this.progress,Math.max(baoliTime, me.nowLongTime))
                me.sumTime = me.timeResult(me.videoObj.j2s_getDuration());
                // console.log( me.sumTime)
            }, 1000)
            // console.log('timer的值')
            // console.log(this.timer)
        },
        //返回00时00分00秒格式
        timeResult: function (time) {
            let secondTime = Number.parseInt(time);
            let minuteTime = 0;
            let hourTime = 0;
            let result = '';
            if (time > 60) {
                minuteTime = Number.parseInt(time / 60);
                secondTime = Number.parseInt(time % 60);
                if (minuteTime > 60) {
                    hourTime = Number.parseInt(minuteTime / 60);
                    minuteTime = Number.parseInt(minuteTime % 60);
                }
            }
            hourTime >= 10 ? result += hourTime + '时' : result += '0' + hourTime + '时';
            minuteTime >= 10 ? result += minuteTime + '分' : result += '0' + minuteTime + '分';
            secondTime >= 10 ? result += secondTime + '秒' : result += '0' + secondTime + '秒';
            return result;
        },
    },
    created(){
        this.id = this.studyId;
        this.time = this.studytime;
    },
    mounted(){
        // console.log('有木有呀')
        this.getResourse();
    }
}